/**
 * MontiPower — Quote List engine
 * A no-account "request quote on these N products" flow.
 * Persists to localStorage; renders a drawer, count badges, and a floating button.
 * Sends as a single enquiry via the contact form on /pages/quote.
 */
(function () {
  'use strict';

  var KEY = 'mp_quote_list';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    syncUI();
  }
  function count() { return read().reduce(function (n, i) { return n + (i.qty || 1); }, 0); }
  function find(handle) { return read().findIndex(function (i) { return i.handle === handle; }); }

  function add(item) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === item.handle; });
    if (idx > -1) { list[idx].qty = (list[idx].qty || 1) + (item.qty || 1); }
    else { list.push({ handle: item.handle, title: item.title, sku: item.sku || '', url: item.url || '', qty: item.qty || 1 }); }
    write(list);
    toast(item.title + ' added to your quote list');
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  function setQty(handle, qty) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx > -1) {
      if (qty <= 0) { list.splice(idx, 1); } else { list[idx].qty = qty; }
      write(list);
    }
  }
  function clear() { write([]); }

  /* ── Toast ────────────────────────────────────────────────── */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('mp-quote-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'mp-quote-toast';
      t.className = 'quote-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  /* ── Sync all UI (badges, buttons, drawer, float btn) ─────── */
  function syncUI() {
    var c = count();
    document.querySelectorAll('[data-quote-count]').forEach(function (el) {
      el.textContent = c;
      el.style.display = c > 0 ? '' : 'none';
    });
    // Float button
    var fab = document.getElementById('quote-fab');
    if (fab) fab.style.display = c > 0 ? '' : 'none';
    // Let CSS know the fab is present, so the back-to-top button can sit above it
    document.body.classList.toggle('has-quote-fab', c > 0);
    // Button states (in quote vs not)
    document.querySelectorAll('[data-quote-add]').forEach(function (btn) {
      var handle = btn.getAttribute('data-quote-add');
      var inList = find(handle) > -1;
      btn.classList.toggle('is-added', inList);
      var label = btn.querySelector('[data-quote-label]');
      if (label) label.textContent = inList ? 'In quote ✓' : (btn.getAttribute('data-quote-label-default') || 'Add to quote');
    });
    renderDrawer();
    renderReviewPage();
  }

  /* ── Drawer ───────────────────────────────────────────────── */
  function renderDrawer() {
    var body = document.getElementById('quote-drawer-body');
    if (!body) return;
    var list = read();
    if (!list.length) {
      body.innerHTML = '<div class="quote-drawer__empty"><p>Your quote list is empty.</p><a href="/collections/all" class="btn btn--red btn--sm" data-quote-close>Browse products</a></div>';
      var f = document.getElementById('quote-drawer-footer');
      if (f) f.style.display = 'none';
      return;
    }
    var html = '<ul class="quote-drawer__items">';
    list.forEach(function (i) {
      html += '<li class="quote-drawer__item" data-handle="' + i.handle + '">' +
        '<div class="quote-drawer__item-info">' +
          '<a href="' + i.url + '" class="quote-drawer__item-title">' + i.title + '</a>' +
          (i.sku ? '<p class="quote-drawer__item-sku">' + i.sku + '</p>' : '') +
        '</div>' +
        '<div class="quote-drawer__item-controls">' +
          '<div class="qty-stepper qty-stepper--sm">' +
            '<button type="button" class="qty-stepper__btn" data-quote-down="' + i.handle + '">−</button>' +
            '<input type="number" class="qty-stepper__input" value="' + (i.qty||1) + '" min="1" data-quote-qty="' + i.handle + '">' +
            '<button type="button" class="qty-stepper__btn" data-quote-up="' + i.handle + '">+</button>' +
          '</div>' +
          '<button type="button" class="quote-drawer__item-remove" data-quote-remove="' + i.handle + '">Remove</button>' +
        '</div>' +
      '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    var foot = document.getElementById('quote-drawer-footer');
    if (foot) foot.style.display = '';
  }

  /* ── Review page (/pages/quote) ───────────────────────────── */
  function buildListText() {
    return read().map(function (i, n) {
      return (n + 1) + '. ' + i.title + (i.sku ? ' (' + i.sku + ')' : '') + ' — Qty: ' + (i.qty || 1);
    }).join('\n');
  }
  function renderReviewPage() {
    var wrap = document.getElementById('quote-review-list');
    if (!wrap) return;
    var list = read();
    if (!list.length) {
      wrap.innerHTML = '<div class="customer-empty"><p>Your quote list is empty.</p><a href="/collections/all" class="btn btn--red">Browse products</a></div>';
    } else {
      var html = '<table class="order-table"><thead><tr><th>Product</th><th>SKU</th><th>Qty</th><th></th></tr></thead><tbody>';
      list.forEach(function (i) {
        html += '<tr data-handle="' + i.handle + '">' +
          '<td><a href="' + i.url + '">' + i.title + '</a></td>' +
          '<td>' + (i.sku || '—') + '</td>' +
          '<td><div class="qty-stepper qty-stepper--sm"><button type="button" class="qty-stepper__btn" data-quote-down="' + i.handle + '">−</button><input type="number" class="qty-stepper__input" value="' + (i.qty||1) + '" min="1" data-quote-qty="' + i.handle + '"><button type="button" class="qty-stepper__btn" data-quote-up="' + i.handle + '">+</button></div></td>' +
          '<td><button type="button" class="quote-drawer__item-remove" data-quote-remove="' + i.handle + '">Remove</button></td>' +
        '</tr>';
      });
      html += '</tbody></table>';
      wrap.innerHTML = html;
    }
    // Fill hidden field in the quote contact form
    var hidden = document.getElementById('quote-list-field');
    if (hidden) hidden.value = list.length ? buildListText() : '';
    var submitBtn = document.getElementById('quote-submit');
    if (submitBtn) submitBtn.disabled = !list.length;
  }

  /* ── Event delegation ─────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-quote-add]');
    if (addBtn) {
      e.preventDefault();
      var handle = addBtn.getAttribute('data-quote-add');
      if (find(handle) > -1) { remove(handle); }
      else {
        add({
          handle: handle,
          title: addBtn.getAttribute('data-quote-title') || handle,
          sku: addBtn.getAttribute('data-quote-sku') || '',
          url: addBtn.getAttribute('data-quote-url') || ''
        });
      }
      return;
    }
    var open = e.target.closest('[data-quote-open]');
    if (open) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-quote-close]')) { e.preventDefault(); closeDrawer(); return; }

    var up = e.target.closest('[data-quote-up]');
    var down = e.target.closest('[data-quote-down]');
    if (up || down) {
      var h = (up || down).getAttribute(up ? 'data-quote-up' : 'data-quote-down');
      var item = read()[find(h)];
      if (item) setQty(h, (item.qty || 1) + (up ? 1 : -1));
      return;
    }
    var rem = e.target.closest('[data-quote-remove]');
    if (rem) { remove(rem.getAttribute('data-quote-remove')); return; }
    var clr = e.target.closest('[data-quote-clear]');
    if (clr) { if (confirm('Clear your quote list?')) clear(); return; }
  });

  document.addEventListener('change', function (e) {
    var q = e.target.closest('[data-quote-qty]');
    if (q) setQty(q.getAttribute('data-quote-qty'), Math.max(1, parseInt(q.value, 10) || 1));
  });

  /* ── Drawer open/close ────────────────────────────────────── */
  function openDrawer() {
    var d = document.getElementById('quote-drawer');
    if (!d) { window.location.href = '/pages/quote'; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quote-drawer-open');
  }
  function closeDrawer() {
    var d = document.getElementById('quote-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('quote-drawer-open');
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Expose for debugging
  window.MPQuote = { add: add, remove: remove, clear: clear, read: read, count: count };

  document.addEventListener('DOMContentLoaded', syncUI);
  syncUI();
})();
